import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('admin_tool_run', '/admin_tool_runs')
const reducer = generator.generate()

export default reducer
